import './card-ticketing.tpl.php';
import './style.scss';
import './result-placeholder.png';
import { addEllipsis } from '../../../jsPlugins/ellipsis';

jQuery($ => {
  addEllipsis($, '.card-ticketing description');
});
